import { useState, useEffect } from 'react';
import { jsPDF } from 'jspdf';

import Video from '../components/Video';
import Questions from '../components/Questions';
import SpeechDetector from '../components/SpeechDetector';
import ToolBar from '../components/ToolBar';


import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

let currentRecorder = null;

const CameraPage = (props) => {
  const questions = localStorage.getItem('questions') !== null ? localStorage.getItem('questions').split(',') : [];
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [questionIndex, setQuestionIndex] = useState(1);
  const [timer, setTimer] = useState(0);
  const [currentTranscript, setCurrentTranscript] = useState('hello');
  const [started, setStarted] = useState(false);
  const [generatedReport, setGeneratedReport] = useState('');


  const generatePatientReport = async () => {
    // Obtain responses from local storage
    const questions = localStorage.getItem('questions') ? localStorage.getItem('questions').split(',') : ["NA"];
    const prompt = constructPrompt(questions);
    const primarySymptom = localStorage.getItem('primarySymptom') || "Headache";
    const activeMedication = localStorage.getItem('activeMedication') || "None";

    try {
        const response = await fetch('http://localhost:5002/api/prompt/report', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ primarySymptom, activeMedication, prompt }),
        });

        const result = await response.json();
        console.log('Received data:', result);
        //setReportResult(result.response);
        const path = `./reports/PatientReport_${Date.now()}.pdf`;
        convertToPDF(result.response);
    } catch (error) {
        console.error('Error generating report:', error.message);
    }
};

  const constructPrompt = (questions) => {
    // Combine questions and answers to create a prompt
    // Customize this based on your data structure
    const answers = localStorage.getItem('answers').split(',');
    const pairs = questions.map((question, index) => `${question}: ${answers[index]}`);
    return pairs.join('\n');
  };

  const convertToPDF = (text,path) => {
    // Create a new PDF document
    const pdf = new jsPDF();

    // Add the generated report text to the PDF
    pdf.text(text, 10, 10);

    // Save the PDF or open it in a new tab
    pdf.save(path);
    const blob = pdf.output('blob');
  };

  const moveNext = async () => {
    console.log(transcript);
    let answers = localStorage.getItem('answers') || "";
    answers = answers + ',' + transcript;
    localStorage.setItem('answers', answers);
    resetTranscript();
    if (questionIndex < questions.length) {
      setQuestionIndex(questionIndex + 1);
      console.log(currentTranscript);

    }
    else {
      generatePatientReport();
      props.setNext();
      //await currentRecorder.stop(questionIndex);
    }
  }
  const moveBack = async () => {
    if (questionIndex > 1) {
      console.log(currentTranscript);
      setQuestionIndex(questionIndex - 1);
    }
  }
  useEffect(() => {
    if (started) {
      setTimeout(() => {
        setTimer(timer + 1);
      }, 1000);
    }
  }, [timer]);

  const recordAudio = () =>
    new Promise(async resolve => {
      /*const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream, { audioBitsPerSecond: 128000, mimeType: "audio/ogg" });
      const audioChunks = [];
  
      mediaRecorder.addEventListener("dataavailable", event => {
        audioChunks.push(event.data);
      });
  
        const start = () => {
            mediaRecorder.start();
            console.log('recording started!');
        }
  
      const stop = (index) =>
        new Promise(resolve => {
          mediaRecorder.addEventListener("stop", () => {
            const audioBlob = new Blob(audioChunks, { type: "audio/ogg" });
            const audioUrl = URL.createObjectURL(audioBlob);
            const audio = new Audio(audioUrl);
            const play = () => audio.play();
            resolve({ audioBlob, audioUrl, play });
  /*
          
            const response = await fetch(`https://speech.googleapis.com/v1/speech:recognize?key=${process.env.REACT_APP_API_KEY}`, {
              method: 'POST',
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(payload),
            }).then(response => response.json())
              .then(data => {
                  console.log("Successful API call!");
                  console.log(data);
              })
              .catch(error => {
                  throw new Error(error);
              });
  
  
            // TODO: Replace with google speech to text response
            setRecordings((recordings) => {
              const newRecordings = {...recordings};
              newRecordings[index] = audioUrl;
            });
          });
  
          mediaRecorder.stop();
          console.log({...recordings});
        });
  
      resolve({ start, stop });*/
      console.log('recording is gone');
    });


  const startRecording = async () => {
    //currentRecorder = await recordAudio();
    //currentRecorder.start();
  }

  return (
    <div>
      <Video started={started} data={props.data} setData={props.setData} setEmotions={props.setEmotions} SpeechRecognition={SpeechRecognition} transcript={transcript} resetTranscript={resetTranscript} />
      <SpeechDetector setCurrentTranscript={setCurrentTranscript} startTimer={() => { setStarted(true); setTimer(1); }} startRecording={startRecording} SpeechRecognition={SpeechRecognition} transcript={transcript} resetTranscript={resetTranscript} />
      <Questions questionIndex={questionIndex} moveNext={moveNext} moveBack={moveBack} />
      <ToolBar timer={timer} moveNext={moveNext} moveBack={moveBack} SpeechRecognition={SpeechRecognition} transcript={transcript} resetTranscript={resetTranscript} />
    </div>
  )
}

export default CameraPage;